<template>
  <div class="admin-wrapper form-settings" v-if="Object.keys(form_translation) != 0">
    <div class="form-wrapper">
      <div class="container form-page">
        <div class="row form-header">
          <el-tooltip
              effect="light"
              content="Наименование университета"
              placement="left-start"
              :value="true"
              :manual="true">
            <h4 class="kafu-title col-md-10 col-12" v-html="form_translation[currentLanguage].uni_title"></h4>
          </el-tooltip>
          <el-tooltip
              effect="light"
              content="Описание университета"
              placement="left-start"
              :value="true"
              :manual="true">
            <p class="form-description col-md-10 col-12" v-html="form_translation[currentLanguage].uni_description"></p>
          </el-tooltip>
        </div>

        <div class="row form-banner">
          <div class="col-12">
            <el-tooltip
                effect="light"
                content="Наименование формы"
                placement="left-start"
                :value="true"
                :manual="true">
              <h1 class="form-title" v-html="form_translation[currentLanguage].form_title"></h1>
            </el-tooltip>
          </div>
          <el-tooltip
              effect="light"
              content="Блок 'Номера приёмной комисии'"
              placement="bottom"
              :value="true"
              :manual="true">
            <div class="col-md-3 col-12 form-contacts">
              <h6>{{ $t('form.contacts_title', currentLanguage) }}</h6>
              <div v-html="form_translation[currentLanguage].contacts_col"></div>
            </div>
          </el-tooltip>
          <el-tooltip
              effect="light"
              content="Блок 'Контактная информаци'"
              placement="bottom"
              :value="true"
              :manual="true">
            <div class="col-md-6 col-12 form-contacts" v-html="form_translation[currentLanguage].address_col"></div>
          </el-tooltip>
          <div class="col-md-3 col-12">
            <img :src="require('@/assets/img/kafu-logo.png')" class="logo" />
          </div>
        </div>
      </div>
    </div>

    <el-tabs type="card" v-model="currentLanguage">
      <el-tab-pane label="Русский" name="ru"></el-tab-pane>
      <el-tab-pane label="Казахский" name="kz"></el-tab-pane>
      <el-tab-pane label="Английский" name="en"></el-tab-pane>
    </el-tabs>

    <el-form>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Наименование университета">
              <el-input v-model="form_translation[currentLanguage].uni_title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Краткое описание университета">
              <el-input type="textarea" rows="5" v-model="form_translation[currentLanguage].uni_description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Наименование формы">
              <el-input v-model="form_translation[currentLanguage].form_title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="2" justify="space-between">
          <el-col :span="12">
            <el-form-item label="Блок 'Номера приёмной комисии'">
              <vue-editor
                  v-model="form_translation[currentLanguage].contacts_col"
                  :editorToolbar="editorToolbar"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Блок 'Контактная информаци'" prop="form_translation">
              <vue-editor
                  v-model="form_translation[currentLanguage].address_col"
                  :editorToolbar="editorToolbar"
              />
            </el-form-item>
          </el-col>
        </el-row>
      <el-row>
        <el-button @click="save">Сохранить</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import settingsApi from '@/api/settings'
import { VueEditor } from "vue2-editor";

export default {
  components: {VueEditor},
  data(){
    return {
      appLanguages: ['ru', 'en', 'kz'],
      form_translation: {},
      default_translation: {
        ru: {
          uni_title: '',
          uni_description: '',
          form_title: '',
          contacts_col: '',
          address_col: ''
        },
        en: {
          uni_title: '',
          uni_description: '',
          form_title: '',
          contacts_col: '',
          address_col: ''
        },
        kz: {
          uni_title: '',
          uni_description: '',
          form_title: '',
          contacts_col: '',
          address_col: ''
        },
      },
      currentLanguage: 'ru',
      customModules: [
        {
          alias: "phone_link",
          module: this.phoneLink
        }
      ],
      editorToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{list: "ordered"}, {list: "bullet"}, {list: "check"}],
        ["link"]
      ]
    }
  },
  mounted() {
    settingsApi.getSetting('form_translation')
        .then(response => {
          if(!('error' in response.data)) this.form_translation = response.data.value
          else this.form_translation = {...this.default_translation}
        })
  },
  methods: {
    phoneLink(value){
      if (value) {
        var href = prompt('Enter the URL');
        this.quill.format('link', href);
      } else {
        this.quill.format('link', false);
      }
    },
    save(){
      settingsApi.updateSettings([{
        name: 'form_translation',
        type: 'object',
        title: 'Переводы формы',
        value: this.form_translation
      }])
          .then(() => this.$message({message: 'Переводы формы обновлены', type: 'success'}))
    }
  }
}
</script>